import styled from '@emotion/styled'
import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { AnalyticsQueryDashboard, MappedName } from '@pubstack/common/src/analytics/query'
import { useAtom } from 'jotai'
import { FunctionComponent } from 'react'
import { LazyVisible } from '~/components/LazyVisible'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { contextState } from '~/state'
import { WithClassName } from '~/types/utils'
import { filterContextDimByName } from '~/utils/analytics'
import { OverviewRevenue } from './revenue/OverviewRevenue'
import { OverviewTimeline } from './timeline/OverviewTimeline'

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 16px;
  }
`

type OverviewPageProps = WithClassName
const BaseOverviewPage: FunctionComponent<OverviewPageProps> = ({ className }) => {
  const dimensions: Dimension[] = ['tagId', 'bidder', 'adUnit', 'device', 'country', 'size', 'pubstackRefresh', 'abTestPopulation', 'stackIdVersion']
  const dashboard: AnalyticsQueryDashboard = { name: 'overview', filterType: 'auctions' }
  const [context, setContext] = useAtom(contextState)
  const currencySymbol = useScopeCurrency()

  const breadcrumbs = useBreadcrumbs()

  const onValueSelect = (name: MappedName, dimension: Dimension) => {
    setContext((context) => filterContextDimByName(context, name, dimension))
  }

  return (
    <AnalyticsPage
      className={className}
      onRefreshClick={() => {
        setContext({ ...context })
      }}
      filterDimensions={dimensions}
      dashboard={dashboard}
      comparedTo={true}
      title={breadcrumbs}
      showMinorDataToggle={true}
    >
      <PageContent>
        <OverviewTimeline context={context} dimensions={dimensions} currencySymbol={currencySymbol} />
        <LazyVisible minHeight={400}>
          <OverviewRevenue context={context} dimensions={dimensions} currencySymbol={currencySymbol} onRevenueChartSelect={onValueSelect} />
        </LazyVisible>
      </PageContent>
    </AnalyticsPage>
  )
}
export const OverviewPage = styled(BaseOverviewPage)``
